import { render, staticRenderFns } from "./SalSobCfg.vue?vue&type=template&id=cc3cf558&scoped=true&"
import script from "./SalSobCfg.vue?vue&type=script&lang=js&"
export * from "./SalSobCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3cf558",
  null
  
)

export default component.exports